import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    hostAddress: string;
    systemActiveSubject = new BehaviorSubject<boolean>(true); // holds current value
    systemActive = this.systemActiveSubject.asObservable(); // subscribed to by components

    public get systemActiveValue(): boolean {
        return this.systemActiveSubject.value;
    }

    constructor(@Inject('BASE_URL') baseUrl: string, private http: HttpClient) {
        this.hostAddress = baseUrl;
    }

    // calls next() on the BehaviorSubject to
    changeSystemStatus(active) {
        this.systemActiveSubject.next(active);
    }

    IsSystemActive() {
        return this.http
            .get<boolean>(this.hostAddress + 'api/auth/isSystemActive', {})
            .pipe(
                catchError((error) => {
                    console.error(error.message);
                    return of([]);
                })
            )
            .subscribe((active: boolean) => {
                this.systemActiveSubject.next(active);
            });
    }
}
